"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableState = void 0;
var tslib_1 = require("tslib");
var ObservableState = /** @class */ (function () {
    function ObservableState(initialState) {
        this.observers = [];
        this.state = initialState;
    }
    ObservableState.prototype.getState = function () {
        return this.state;
    };
    ObservableState.prototype.addObserver = function (observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
        }
    };
    ObservableState.prototype.removeObserver = function (observer) {
        var index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    };
    ObservableState.prototype.updateState = function (newState) {
        this.state = tslib_1.__assign(tslib_1.__assign({}, this.state), newState);
        this.notifyObservers();
    };
    ObservableState.prototype.notifyObservers = function () {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            observer(this.state);
        }
    };
    return ObservableState;
}());
exports.ObservableState = ObservableState;
